import { render, staticRenderFns } from "./ListProdukteItem.vue?vue&type=template&id=7f4ac8fe&scoped=true&"
import script from "./ListProdukteItem.vue?vue&type=script&lang=js&"
export * from "./ListProdukteItem.vue?vue&type=script&lang=js&"
import style0 from "./ListProdukteItem.vue?vue&type=style&index=0&id=7f4ac8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4ac8fe",
  null
  
)

component.options.__file = "ListProdukteItem.vue"
export default component.exports